import React from 'react';

import styled from 'styled-components';

import SlingLogo from '../logo.svg';

const Logo = styled(SlingLogo)`
  margin-bottom: 50px;
`;

const LegacyWrapper = ({ children }) => (
  <header className="App-header">
    <Logo />
    {children}
  </header>
);

export default LegacyWrapper;
